"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _functions = require("../@functions");
require("../@assets/sass/custom/SimpleButton.scss");
var _excluded = ["tag", "children", "className", "onClick", "variant", "iconed", "disabled", "round", "bgColor", "textColor", "fullWidth", "style", "tooltip", "tooltipPosition", "dark", "textTransform", "outlined"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * @typedef SimpleButtonProps
 * @type {{
 *     tag?: keyof JSX.IntrinsicElements,
 *     children: React.ReactNode,
 *     className?: string,
 *     onClick?: (evt: React.MouseEvent) => void,
 *     variant?:
 *          "clear" | "reject" | "save" | "delete" | "success" |
 *          "info" | "cancel" | "gold" | "google" | "facebook" |
 *          "linkedin",
 *     bgColor?: string;
 *     textColor?: string;
 *     fullWidth?: boolean;
 *     iconed?: boolean;
 *     disabled?: boolean;
 *     round?: boolean;
 *     tooltip?: string;
 *     tooltipPosition?: "left" | "right" | "top" | "bottom";
 *     dark?: boolean;
 *     textTransform?: "capitalize" | "lowercase" | "uppercase" | "none";
 *     outlined?: boolean;
 * } & React.HTMLProps<HTMLButtonElement>}
 */

/**
 * @param {SimpleButtonProps} props
 * @returns {JSX.Element}
 */
function SimpleButton(props) {
  var _classNames;
  var _props$tag = props.tag,
    tag = _props$tag === void 0 ? "button" : _props$tag,
    children = props.children,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    onClick = props.onClick,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? "" : _props$variant,
    _props$iconed = props.iconed,
    iconed = _props$iconed === void 0 ? false : _props$iconed,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$round = props.round,
    round = _props$round === void 0 ? false : _props$round,
    bgColor = props.bgColor,
    textColor = props.textColor,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    tooltip = props.tooltip,
    _props$tooltipPositio = props.tooltipPosition,
    tooltipPosition = _props$tooltipPositio === void 0 ? "top" : _props$tooltipPositio,
    _props$dark = props.dark,
    dark = _props$dark === void 0 ? false : _props$dark,
    textTransform = props.textTransform,
    _props$outlined = props.outlined,
    outlined = _props$outlined === void 0 ? false : _props$outlined,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);

  /**
   * @type {any}
   */
  var Wrapper = tag;
  return /*#__PURE__*/_react["default"].createElement(Wrapper, (0, _extends2["default"])({
    className: (0, _functions.classNames)("SimpleButton", (_classNames = {}, (0, _defineProperty2["default"])(_classNames, className, !!className), (0, _defineProperty2["default"])(_classNames, "SimpleButton--clear", variant === "clear"), (0, _defineProperty2["default"])(_classNames, "SimpleButton--reject", variant === "reject"), (0, _defineProperty2["default"])(_classNames, "SimpleButton--save", variant === "save"), (0, _defineProperty2["default"])(_classNames, "SimpleButton--success", variant === "success"), (0, _defineProperty2["default"])(_classNames, "SimpleButton--delete", variant === "delete"), (0, _defineProperty2["default"])(_classNames, "SimpleButton--info", variant === "info"), (0, _defineProperty2["default"])(_classNames, "SimpleButton--cancel", variant === "cancel"), (0, _defineProperty2["default"])(_classNames, "SimpleButton--google", variant === "google"), (0, _defineProperty2["default"])(_classNames, "SimpleButton--facebook", variant === "facebook"), (0, _defineProperty2["default"])(_classNames, "SimpleButton--linkedin", variant === "linkedin"), (0, _defineProperty2["default"])(_classNames, "SimpleButton--gold", variant === "gold"), (0, _defineProperty2["default"])(_classNames, "SimpleButton--iconed", iconed), (0, _defineProperty2["default"])(_classNames, "SimpleButton--round", round), (0, _defineProperty2["default"])(_classNames, "SimpleButton--fullWidth", fullWidth), (0, _defineProperty2["default"])(_classNames, "SimpleButton--dark", dark), (0, _defineProperty2["default"])(_classNames, "SimpleButton--outlined", outlined), _classNames)),
    onClick: onClick,
    disabled: !!disabled,
    "data-tooltip": tooltip || undefined,
    "data-position": tooltipPosition,
    style: _objectSpread({
      color: textColor,
      backgroundColor: bgColor,
      textTransform: textTransform
    }, style)
  }, rest), children);
}
SimpleButton.propTypes = {
  tag: _propTypes["default"].string,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  variant: _propTypes["default"].string,
  iconed: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  round: _propTypes["default"].bool,
  bgColor: _propTypes["default"].string,
  textColor: _propTypes["default"].string,
  fullWidth: _propTypes["default"].bool,
  style: _propTypes["default"].object,
  tooltip: _propTypes["default"].string,
  tooltipPosition: _propTypes["default"].string,
  dark: _propTypes["default"].bool,
  textTransform: _propTypes["default"].string,
  outlined: _propTypes["default"].bool
};
var _default = SimpleButton;
exports["default"] = _default;